import { useEffect, useState } from 'react'

import EntryLoader from './EntryLoader'

const START_LOADING = null
const STILL_LOADING = 'loading'
const ERROR_LOADING = 'hmm, something went wrong'

const START_TIME = 1000
const ERROR_TIME = 5000

export default function SuspenseLoader() {
    const [state, setState] = useState<string | null>(START_LOADING)

    useEffect(() => {
        const timer1 = setTimeout(() => setState(STILL_LOADING), START_TIME)
        const timer2 = setTimeout(() => setState(ERROR_LOADING), ERROR_TIME)

        return () => {
            clearTimeout(timer1)
            clearTimeout(timer2)
        }
    }, [])

    return <div style={EntryLoader.style}>{state}</div>
}
